"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var react_router_dom_1 = require("react-router-dom");
var ApiRequestsContext_1 = require("../apiRequests/ApiRequestsContext");
var ErrorCatcher_1 = require("../components/ErrorCatcher");
var UIActionsContext_1 = require("../uiActions/UIActionsContext");
var SiteUrlsContext_1 = require("../urls/SiteUrlsContext");
/**
 * Provider for the EmbeddableVizClientLineagePanel since it doesn't need the [[ApiRequests]] object
 */
var VizClientDataCatalogProvider = /** @class */ (function (_super) {
    __extends(VizClientDataCatalogProvider, _super);
    function VizClientDataCatalogProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VizClientDataCatalogProvider.prototype.render = function () {
        return (React.createElement(ErrorCatcher_1.ErrorCatcher, null,
            React.createElement(react_apollo_1.ApolloProvider, { client: this.props.client },
                React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: this.props.siteUrls }, this.props.children))));
    };
    return VizClientDataCatalogProvider;
}(React.Component));
exports.VizClientDataCatalogProvider = VizClientDataCatalogProvider;
/**
 * All components exported from this module should be wrapped in a DataCatalogProvider,
 * so they have access to Apollo and shared URLs.
 */
var DataCatalogProvider = /** @class */ (function (_super) {
    __extends(DataCatalogProvider, _super);
    function DataCatalogProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataCatalogProvider.prototype.render = function () {
        return (React.createElement(ErrorCatcher_1.ErrorCatcher, null,
            React.createElement(react_apollo_1.ApolloProvider, { client: this.props.client },
                React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: this.props.siteUrls },
                    React.createElement(ApiRequestsContext_1.ApiRequestsContext.Provider, { value: this.props.apiRequests },
                        React.createElement(UIActionsContext_1.UIActionsContext.Provider, { value: this.props.uiActions }, this.props.children))))));
    };
    return DataCatalogProvider;
}(React.Component));
exports.DataCatalogProvider = DataCatalogProvider;
/**
 * Many (but not all) components exported from this module require a HashRouter.
 * This component provides one, and should be used instead of the above wrapper for
 * components that will be used in an environment where a HashRouter is not already provided.
 */
var DataCatalogProviderWithRouter = /** @class */ (function (_super) {
    __extends(DataCatalogProviderWithRouter, _super);
    function DataCatalogProviderWithRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataCatalogProviderWithRouter.prototype.render = function () {
        return (React.createElement(react_router_dom_1.HashRouter, null,
            React.createElement(DataCatalogProvider, __assign({}, this.props), this.props.children)));
    };
    return DataCatalogProviderWithRouter;
}(React.Component));
exports.DataCatalogProviderWithRouter = DataCatalogProviderWithRouter;
//# sourceMappingURL=DataCatalogProvider.js.map